import React from "react";

const Hero = () => {
  return (
    <section className="pt-20 bg-gradient-to-r from-gray-800 to-gray-700 text-white text-center py-16">
      <h1 className="text-4xl md:text-6xl font-bold mb-4">
        Premium Smoking Accessories
      </h1>
      <p className="text-gray-300 mb-6 text-lg">
        Explore top-quality grinders, papers, vapes, and more for a smooth experience.
      </p>
      <button className="bg-amber-600 hover:bg-amber-500 px-6 py-3 rounded-lg text-lg font-semibold">
        Shop Now
      </button>
    </section>
  );
};

export default Hero;
